import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { ZoonosesComponent } from './zoonoses/zoonoses.component';

const routes: Routes = [
  { path: '', redirectTo: '/zoonoses', pathMatch: 'full' },
  { path: 'zoonoses',  component: ZoonosesComponent },
  { path: 'login', component: LoginComponent },
//  { path: 'detail/:id', component: HeroDetailComponent },
//  { path: 'heroes',     component: HeroesComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/bdegroot/Projects/vgtropics-ph/src/app/app-routing.module.ts